<template>
  <div>
    <div v-if="canViewPage">
      <div class="pa-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            headline="Đơn đăng ký đồng phục"
            :link="[
              {
                text: 'Đơn đăng ký đồng phục',
                href: './uniform-orders-register',
              },
            ]"
          />
        </div>
        <div>
          <div class="d-flex align-center gap-4 mb-2" style="justify-self: right" v-if="!canDisplayByStudent">
            <div class="uniform-status" @mouseover="showHistory = true" @mouseleave="showHistory = false">
              {{ statusText }}
              <div class="history-dropdown">
                <v-list v-if="showHistory && uniformConfig.history && uniformConfig.history.length">
                  <v-list-item v-for="(item, index) in uniformConfig.history" :key="index">
                    <v-list-item-content>
                      <v-list-item-title> {{ item.user.name }} - {{ item.action }} </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ item.timestamp }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </div>

            <v-btn
              class="ml-5"
              outlined
              :color="uniformConfig.isOpen ? 'error' : 'success'"
              @click="toggleRegistration"
            >
              <v-icon left>{{ uniformConfig.isOpen ? 'mdi-lock' : 'mdi-lock-open' }}</v-icon>
              {{ uniformConfig.isOpen ? 'Đóng đăng ký' : 'Mở đăng ký' }}
            </v-btn>
          </div>
          <div style="justify-self: right">
            <v-btn
              v-if="$vuetify.breakpoint.mdAndUp && !canDisplayByStudent"
              outlined
              color="warning"
              @click="showSizeChartDialog = true"
            >
              <v-icon left>mdi-file-image</v-icon> Bảng quy đổi kích cỡ
            </v-btn>
            <UniformSizeChartDialog :state="showSizeChartDialog" @update:state="showSizeChartDialog = $event" />
            <v-btn
              v-if="$vuetify.breakpoint.mdAndUp && !canDisplayByStudent"
              outlined
              color="success"
              @click="exportExcel"
              class="ml-5"
            >
              <v-icon left>mdi-file-excel</v-icon> Xuất Excel
            </v-btn>
            <v-btn
              depressed
              dark
              color="primary"
              @click="newDialog = !newDialog"
              class="ml-5"
              v-if="!hasOrderThisMonth"
            >
              <v-icon>mdi-plus</v-icon> Tạo đơn đăng ký đồng phục
            </v-btn>
          </div>
        </div>
      </div>

      <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
        <UniformOrdersRegisterFilter @onFilterChanged="onFilterChange" />
      </v-card>

      <v-card outlined class="mx-4 elevation-0">
        <UniformOrdersRegisterTable ref="table" />
      </v-card>
      <UniformOrderNewDialog :state="newDialog" @updated="onFilterChange()" />
    </div>
    <div v-else></div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'
import utils from '@/plugins/utils'
import { UniformOrders } from '@/plugins/api'
import UniformOrdersRegisterTable from '@/modules/uniformOrdersRegister/UniformOrdersRegisterTable.vue'
import UniformOrdersRegisterFilter from '@/modules/uniformOrdersRegister/UniformOrdersRegisterFilter.vue'
import UniformSizeChartDialog from '@/views/uniformOrdersRegister/UniformSizeChartDialog.vue'

export default {
  components: {
    Breadcrumbs,
    UniformOrdersRegisterTable,
    UniformOrdersRegisterFilter,
    UniformSizeChartDialog,
    UniformOrderNewDialog: () => import('@/modules/uniformOrdersRegister/UniformOrderNewDialog.vue'),
  },
  props: {},
  data() {
    return {
      showSizeChartDialog: false,
      newDialog: false,
      type: '',
      showHistory: false,
    }
  },
  computed: {
    ...mapState('UniformOrdersRegister', ['uniformConfig', 'uniformOrdersSearchParams', 'date']),

    canViewPage() {
      return true
      // return this.$auth.policies['uniform-orders-list'] || get(this.$auth.user, 'role.type') === 'student'
    },
    canDisplayByStudent() {
      return get(this.$auth.user, 'role.type') === 'student'
    },
    statusText() {
      if (!this.uniformConfig.history || !this.uniformConfig.history.length) {
        return 'Chưa có lịch sử cấu hình'
      }
      // const lastAction = this.uniformConfig.history[this.uniformConfig.history.length - 1]
      const lastAction = this.uniformConfig.history[0]
      return `${lastAction.action} lần cuối vào ${lastAction.timestamp}`
    },
    hasOrderThisMonth() {
      if (!this.canDisplayByStudent) return false

      const now = new Date()
      const currentMonth = now.getMonth() + 1
      const currentYear = now.getFullYear()

      const orders = this.$store.state.UniformOrdersRegister.uniformOrderss || []
      return orders.some(order => {
        if (!order.orderedAt || (order.status !== 'pending' && order.status !== 'confirmed')) return false

        // orderedAt dạng '27/05/2025, 15:45'
        const datePart = order.orderedAt.split(',')[0] // '27/05/2025'
        const [day, month, year] = datePart.split('/')

        return parseInt(month) === currentMonth && parseInt(year) === currentYear
      })
    },
  },
  methods: {
    ...mapActions('UniformOrdersRegister', ['setDate', 'fetchUniformConfig', 'toggleRegistrationStatus']),

    async toggleRegistration() {
      await this.toggleRegistrationStatus()
    },
    async refresh(query) {
      this.$refs.table.refresh(query)
    },
    onFilterChange(query) {
      // if (get(query, 'date')) this.setDate(query.date)
      if (get(query, 'fromDate') && get(query, 'toDate')) {
        this.setDate({ fromDate: query.fromDate, toDate: query.toDate })
      }
      this.refresh(query)
    },

    async exportExcel() {
      this.$loading.active = true
      try {
        // 1. Chuẩn bị header cho file Excel
        let headers = [
          { text: 'Học sinh', value: 'student' },
          { text: 'Mã số', value: 'code' },
          { text: 'Ngày sinh', value: 'dob' },
          { text: 'Giới tính', value: 'gender' },
          { text: 'Lớp', value: 'class' },
          { text: 'Nội dung đơn', value: 'uniformItems' },
          { text: 'Trạng thái đơn', value: 'status' },
          { text: 'Trạng thái trả', value: 'statusReturned' },
          { text: 'Đối soát trả', value: 'returnTracking' },
          { text: 'Ghi chú', value: 'note' },
          { text: 'Tổng tiền', value: 'totalPrice' },
          { text: 'Ngày đặt hàng', value: 'orderedAt' },
        ]

        // 2. Lấy dữ liệu danh sách đơn hàng từ API
        const list = await UniformOrders.getUniformOrdersRegisterByStudents(this.uniformOrdersSearchParams)
        const uniformOrderss = JSON.parse(JSON.stringify(list))

        // 3. Map lại dữ liệu cho đúng cấu trúc xuất Excel
        const filters = this.$options.filters
        const data = uniformOrderss.map(item => {
          return {
            student: item.student.name,
            code: item.student.code,
            dob: filters.ddmmyyyy(item.student.dob),
            gender: filters.gender(item.student.gender),
            class: get(item, 'student.class.title', ''),
            uniformItems: item.uniformItems
              .map(uni => `${uni.name} - ${uni.optionOne} - ${uni.optionTwo} (${uni.quantity})`)
              .join(',\n '),
            status: this.getStatusText(item.status),
            statusReturned: this.getStatusReturnText(item.statusReturned),
            returnTracking: item.uniformItems
              .map(uni => `${uni.name} - ${uni.optionOne} - ${uni.optionTwo} (${uni.returned || 0}/${uni.quantity})`)
              .join(',\n'),
            note: item.note,
            totalPrice: item.totalPrice,
            orderedAt: item.orderedAt,
          }
        })

        // 4. Tạo tên file với ngày hiện tại
        const date = new Date().toLocaleDateString('vi-VN').replaceAll('/', '-')

        // 5. Xuất file Excel
        utils.exportExcel(data, headers, `${date}_DSDangKyDongPhuc`, { wrapText: true })
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    },
    getStatusText(status) {
      return (
        {
          pending: 'Chờ duyệt',
          confirmed: 'Đã xác nhận',
          cancelled: 'Đã hủy',
        }[status] || 'Không xác định'
      )
    },
    getStatusReturnText(statusReturned) {
      return (
        {
          not_returned: 'Chưa trả',
          waiting_returned: 'Đang trả hàng',
          complete_returned: 'Đã hoàn thành',
        }[statusReturned] || 'Không xác định'
      )
    },
  },
  async created() {
    await this.fetchUniformConfig()
  },
}
</script>
<style scoped>
.uniform-status {
  position: relative;
  display: inline-block;
  cursor: pointer;
  font-weight: normal;
  transition: color 0.3s ease;
}
.history-dropdown {
  position: absolute;
  top: 30px; /* Ngay dưới dòng status */
  left: 0;
  z-index: 10;
  width: 300px;
  background-color: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  overflow: hidden;
}
.history-dropdown v-list {
  max-height: 250px;
  overflow-y: auto;
}

.v-list-item {
  cursor: default;
}

.v-list-item:hover {
  background-color: #f9f9f9;
}
</style>
